/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiftCodeValidation
 */
export interface GiftCodeValidation {
    /**
     * 
     * @type {string}
     * @memberof GiftCodeValidation
     */
    gift_code: string;
}

/**
 * Check if a given object implements the GiftCodeValidation interface.
 */
export function instanceOfGiftCodeValidation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "gift_code" in value;

    return isInstance;
}

export function GiftCodeValidationFromJSON(json: any): GiftCodeValidation {
    return GiftCodeValidationFromJSONTyped(json, false);
}

export function GiftCodeValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiftCodeValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gift_code': json['gift_code'],
    };
}

export function GiftCodeValidationToJSON(value?: GiftCodeValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gift_code': value.gift_code,
    };
}

